// Türkçe-duyarlı, aksan-duyarsız arama normalizasyonu.
// Sadece arama/filtre KARŞILAŞTIRMASI için kullanılır; gösterilen metni değiştirmez.
//
// JavaScript'in dile duyarsız .toLowerCase()'i "İ" (U+0130) harfini
// "i" + birleşik nokta (U+0307) olarak küçültür ve substring eşleşmesini bozar
// (ör. "RABİA".toLowerCase() -> "rabi" + nokta + "a"; "rabia" eşleşmez ama "rabi" eşleşir).
// Bu yüzden tr-TR locale ile küçültüp, Türkçe karakterleri ASCII karşılığına indirger,
// ardından kalan birleşik aksan işaretlerini (U+0300–U+036F) ayıklarız.

const TURKISH_TO_ASCII = {
  "ç": "c",
  "ğ": "g",
  "ı": "i",
  "ö": "o",
  "ş": "s",
  "ü": "u",
};

function isCombiningMark(codePoint) {
  return codePoint >= 0x0300 && codePoint <= 0x036f;
}

export function normalizeSearchText(value) {
  const decomposed = String(value ?? "")
    .toLocaleLowerCase("tr-TR")
    .normalize("NFKD");
  let result = "";
  for (const ch of decomposed) {
    const cp = ch.codePointAt(0);
    if (isCombiningMark(cp)) continue;
    result += TURKISH_TO_ASCII[ch] || ch;
  }
  return result.trim();
}

export function searchMatches(haystack, query) {
  const q = normalizeSearchText(query);
  if (!q) return true;
  return normalizeSearchText(haystack).includes(q);
}
